export default "__VITE_ASSET__Db8$Q_hz__";